/**
 * 4xx - resource upload error messages
 */
export const CP_400 = 'Only one lesson at a time, please!'
export const CP_401 = 'Please upload Notebook files only'
export const CP_402 = 'Unsupported content in this file.'
export const CP_403 = 'We couldn\'t upload this file'
export const CP_404 = 'Couldn\'t connect to the internet'
